module.exports = __webpack_public_path__ + "static/media/Firmware-amico.72a03bc4.svg";